//Escolher tema
export const ThemeOptions = [
  { label: 'Tema Oliv-e', value: 'theme-olive' },
  { label: 'Tema Tem Saúde', value: 'theme-temsaude' },
  { label: 'Tema Tem Saúde - BMG Med', value: 'theme-bmg' },
  { label: 'Tema Mercer Marsh', value: 'theme-mercer-marsh' },
  { label: 'Tema Sempre Marsh', value: 'theme-sempre-marsh' },
  { label: 'Tema Drogaria São Paulo', value: 'theme-dsp' },
  { label: 'Tema EcoVias', value: 'theme-ecovias' },
  { label: 'Tema ESPM', value: 'theme-espm' },
  { label: 'Tema Athena', value: 'theme-athena' }
];

export const YesNoOptions = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' }
];
